<template>
    <div>
        <div
            v-if="status === 'complete'"
            class="text-orange-500">
            {{ rateSid }}
        </div>
        <div
            v-else-if="status === 'error'"
            class="capitalize text-red-500">
            <span class="inline-block">
                Error
            </span>
            <hts-tooltip class="inline-block">
                <span>
                    {{ error }}
                </span>
                <template #reference>
                    <hi-information-circle-icon class="inline-block text-red-500 w-5 h-5" />
                </template>
            </hts-tooltip>
            <hts-form-button
                size="mini"
                class="inline-block ml-1"
                :loading="loading"
                @click="resync">
                ReSync
            </hts-form-button>
        </div>
        <div
            v-else
            class="capitalize text-green-500">
            In process
        </div>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const id = computed(() => {
  const { _id } = params?.value?.data
  return _id || ''
})
const status = computed(() => {
  const { freightekSyncStatus } = params?.value?.data
  return freightekSyncStatus || ''
})
const rateSid = computed(() => {
  const { freightekSyncRateSId } = params?.value?.data
  return freightekSyncRateSId || ''
})
const error = computed(() => {
  const { freightekSyncErrors } = params?.value?.data
  return freightekSyncErrors || ''
})
const loading = ref(false)
const resync = () => {
  loading.value = true

  $api($url.quote.resycn, { uriParams: { ID: id.value } })
    .then(({ data }: any) => {
      Object.assign(params?.value?.data, { freightekSyncStatus: 'in_process' })
      loading.value = false
    })
    .catch(() => {
      loading.value = false
    })
}
</script>
